export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6197.edc28788.jpg";